import "../Management/ContentManagement.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MdAddTask } from "react-icons/md";
import { VscTasklist } from "react-icons/vsc";
import nexticn from "../Components/Assets/svg/chevron-right-solid.svg";
import backicn from "../Components/Assets/svg/back-chevron-right-solid (1).svg";
import { LuNotepadText } from "react-icons/lu";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";
import mail from "../Components/Assets/Management/email-icn.png";
import Swal from "sweetalert2";

// Add this helper function at the top of your component
const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

export function ContentManagement() {
  const navigate = useNavigate();
  const [companyProfile, setCompanyProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showTaskStatus, setShowTaskStatus] = useState(true);
  const [buttonAction, setButtonAction] = useState(null);
  const scrollRef = useRef(null);
  const approvedScrollRef = useRef(null);
  const [topRowTitleSection, setTopRowTitleSection] = useState(true);
  const [NewTask, setNewTask] = useState(false);
  const [showFirstHalf, setShowFirstHalf] = useState(true);
  const [showSecondHalf, setShowSecondHalf] = useState(true);
  const [showCurrentTaskStatus, setShowCurrentTaskStatus] = useState(false);
  const [showCompletedTaskStatus, setShowCompletedTaskStatus] = useState(false);
  const [launchedTaskWindow, setLaunchedWindow] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [approvedTasks, setApprovedTasks] = useState([]);
  const [launchedTasks, setLaunchedTasks] = useState([]);
  const [selectedLaunchedTasks, setSelectedLaunchedTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const [selectedRolledBackTask, setSelectedRolledBackTask] = useState(null);
  const [tempRowStatus, setTempRowStatus] = useState(false);
  const [tempYetRowStatus, setYetTempRowStatus] = useState(false);
  const [showLaunchedTaskDetail, setShowLaunchedTaskDetail] = useState(false);
  const [tempYetLaunchedRowStatus, setTempYetLaunchedRowStatus] =
    useState(false);
  const [submitStatus, setSubmitStatus] = useState("idle"); // idle | submitting | submitted
  const [taskForm, setTaskForm] = useState({
    companyProfileId: "",
    title: "",
    tagline: "",
    taskpurpose: "",
    headline: "",
    offerormessage: "",
    calltoaction: "",
    guidlines: "",
    additionalinfo: "",
    description: "",
    targetPostingDate: "",
    submissionForReview: "",
    currentStatus: "Pending",
    platform_x: false,
    platform_fb: false,
    platform_insta: false,
    platform_li: false,
    platform_via_mail: false,
  });
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    // Validate token by calling /me
    fetch(process.env.REACT_APP_API_URL + "/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Invalid token");
        }
        return res.json();
      })
      .catch(() => {
        localStorage.removeItem("token");
        navigate("/login");
      });
  }, [navigate]);

  const taskHandleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("submitting");
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to create a task", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        navigate("/login");
        return;
      }

      if (
        !taskForm.title ||
        !taskForm.targetPostingDate ||
        !taskForm.submissionForReview
      ) {
        toast.error("Please fill in all required fields", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("companyProfileId", companyProfile._id); // Override what's in taskForm
      formData.append("title", taskForm.title);
      formData.append("tagline", taskForm.tagline);
      formData.append("taskpurpose", taskForm.taskpurpose);
      formData.append("headline", taskForm.headline);
      formData.append("offerormessage", taskForm.offerormessage);
      formData.append("calltoaction", taskForm.calltoaction);
      formData.append("guidlines", taskForm.guidlines);
      formData.append("additionalinfo", taskForm.additionalinfo);
      formData.append("description", taskForm.description);
      formData.append("targetPostingDate", taskForm.targetPostingDate);
      formData.append("submissionForReview", taskForm.submissionForReview);

      // Add referenceImage to the form data if a file is selected
      const referenceImageInput = document.querySelector(
        'input[name="referenceimage"]'
      );
      if (referenceImageInput && referenceImageInput.files[0]) {
        formData.append("referenceImage", referenceImageInput.files[0]);
      }

      // Add these lines:
      formData.append("platform_x", taskForm.platform_x ? "true" : "false");
      formData.append("platform_fb", taskForm.platform_fb ? "true" : "false");
      formData.append(
        "platform_insta",
        taskForm.platform_insta ? "true" : "false"
      );
      formData.append("platform_li", taskForm.platform_li ? "true" : "false");
      formData.append(
        "platform_via_mail",
        taskForm.platform_via_mail ? "true" : "false"
      );

      // Send the request to the server
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/task/create-task`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Important for file uploads
          },
        }
      );

      if (response.data) {
        toast.success("Task created successfully!", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        setSubmitStatus("submitted");
        clickAssignSubmitButton();
        setTaskForm({
          companyProfileId: "",
          title: "",
          tagline: "",
          taskpurpose: "",
          headline: "",
          offerormessage: "",
          calltoaction: "",
          guidlines: "",
          additionalinfo: "",
          description: "",
          targetPostingDate: "",
          submissionForReview: "",
        });
        await fetchRolledBackTasks();
        await fetchTasks();
        setNewTask(false);
        // Reset status after a short delay
        setTimeout(() => setSubmitStatus("idle"), 1500);
      }
    } catch (error) {
      console.error("Error creating task:", error);
      toast.error("Error creating task", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
      setSubmitStatus("idle");
    }
  };
  const handleDeleteTask = async (taskId) => {
    const result = await Swal.fire({
      title: "Are you sure you want to Remove this task?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/task/remove-task/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Task deleted successfully", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });

        // Close the task detail view
        taskStatus(false);

        // Refresh the tasks list
        await fetchTasks();
        await fetchRolledBackTasks();
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      toast.error(error.response?.data?.message || "Error deleting task", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTaskForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // For showing list of task
  const fetchTasks = async () => {
    try {
      if (!companyProfile?._id) {
        console.log("Company profile not loaded yet");
        return;
      }

      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/task/tasks/${companyProfile._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Filter tasks that are not "Approved" or "Posted"
      const filteredTasks = response.data.filter(
        (task) =>
          task.currentStatus !== "Approved" && task.currentStatus !== "Posted"
      );
      setTasks(filteredTasks);

      // Update tempRowStatus based on whether there are tasks to show
      if (filteredTasks.length === 0) {
        setTempRowStatus(false); // No tasks to show
      } else {
        setTempRowStatus(true); // Tasks are available
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Error loading tasks", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  const fetchRolledBackTasks = async () => {
    try {
      if (!companyProfile?._id) return;

      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/task/tasks/${companyProfile._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.filter((task) => task.currentStatus === "Approved")) {
        setYetTempRowStatus(true);
        setApprovedTasks(
          response.data.filter((task) => task.currentStatus === "Approved")
        );
      }
      if (
        response.data.filter((task) => task.currentStatus === "Approved")
          .length === 0
      ) {
        setYetTempRowStatus(false);
      }
      if (response.data.filter((task) => task.currentStatus === "Posted")) {
        setTempYetLaunchedRowStatus(true);
        setLaunchedTasks(
          response.data.filter((task) => task.currentStatus === "Posted")
        );
      }
      if (
        response.data.filter((task) => task.currentStatus === "Posted")
          .length === 0
      ) {
        setTempYetLaunchedRowStatus(false);
      }
    } catch (error) {
      console.error("Error fetching rolled back tasks:", error);
      toast.error("Error loading rolled back tasks", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/company/get-company-profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setCompanyProfile(response.data);
        } else {
          toast.error("Company profile not found", {
            className: "gradient-toast",
            bodyClassName: "gradient-toast-body",
            progressClassName: "gradient-toast-progress",
          });
          navigate("/new-company");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response?.status === 404) {
          toast.error("Please create a company profile first", {
            className: "gradient-toast",
            bodyClassName: "gradient-toast-body",
            progressClassName: "gradient-toast-progress",
          });
          navigate("/new-company");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (companyProfile?._id) {
      // console.log("Fetching tasks for company:", companyProfile._id);
      fetchTasks();
    }
  }, [companyProfile]);

  useEffect(() => {
    if (companyProfile?._id) {
      fetchRolledBackTasks();
    }
  }, [companyProfile]);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -350,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 350,
        behavior: "smooth",
      });
    }
  };
  const approvedScrollLeft = () => {
    if (approvedScrollRef.current) {
      approvedScrollRef.current.scrollBy({
        left: -350,
        behavior: "smooth",
      });
    }
  };

  const approvedScrollRight = () => {
    if (approvedScrollRef.current) {
      approvedScrollRef.current.scrollBy({
        left: 350,
        behavior: "smooth",
      });
    }
  };

  const taskStatus = async (taskId) => {
    try {
      if (taskId === false) {
        setShowFirstHalf(true);
        setTopRowTitleSection(true);
        setShowTaskStatus(true);
        setShowSecondHalf(true);
        setShowCurrentTaskStatus(false);
        setSelectedTask(null);
        await fetchTasks(); // Refresh tasks
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        navigate("/login");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/task/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data) {
        toast.error("No task data received", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        return;
      }

      setShowFirstHalf(false);
      setSelectedTask(response.data);
      setTopRowTitleSection(false);

      setShowTaskStatus(false);
      setShowSecondHalf(false);
      setShowCurrentTaskStatus(true);
      await fetchTasks(); // Refresh tasks
    } catch (error) {
      console.error("Error fetching task:", error);
      toast.error("Error loading task details", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  const handleApprove = async () => {
    try {
      if (!selectedTask?._id) {
        toast.error("No task selected", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        return;
      }

      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/task/update-task/${selectedTask._id}`,
        {
          currentStatus: "Approved",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        toast.success("Task approved successfully", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        await fetchTasks(); // Refresh tasks
        await fetchRolledBackTasks();
        taskStatus(false); // Close detail view
      }
    } catch (error) {
      console.error("Error approving task:", error.response?.data || error);
      toast.error(error.response?.data?.message || "Error approving task", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  const handleRollback = async () => {
    try {
      if (!selectedTask?._id) {
        toast.error("No task selected", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        return;
      }

      if (!feedbackText.trim()) {
        toast.error("Please provide feedback before rolling back", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        return;
      }

      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/task/update-task/${selectedTask._id}`,
        {
          currentStatus: "Roll Back",
          referBackFeedback: feedbackText.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        toast.success("Task rolled back with feedback", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        setFeedbackText("");
        setButtonAction("approve");
        setShowFeedback(false);
        await fetchTasks(); // Refresh tasks
        taskStatus(false); // Close detail view
      }
    } catch (error) {
      console.error("Error rolling back task:", error.response?.data || error);
      toast.error(error.response?.data?.message || "Error rolling back task", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  const fetchTaskDetails = async (taskId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/task/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const task = response.data;
      // console.log("Task details:", task);

      // Display rollback feedback
      if (task.rollbackFeedback && task.rollbackFeedback.length > 0) {
        task.rollbackFeedback.forEach((feedback) => {
          console.log(
            `Feedback: ${feedback.feedback}, Timestamp: ${feedback.timestamp}`
          );
        });
      }
    } catch (error) {
      console.error("Error fetching task details:", error);
    }
  };

  const completedTask = async (taskId) => {
    try {
      if (taskId === false) {
        setTopRowTitleSection(true);
        setShowTaskStatus(true);
        setShowFirstHalf(true);
        setShowSecondHalf(true);
        setShowCompletedTaskStatus(false);
        setSelectedRolledBackTask(null);
        await fetchRolledBackTasks(); // Refresh rolled-back tasks
        return;
      }

      const task = approvedTasks.find((t) => t._id === taskId);
      if (task) {
        setTopRowTitleSection(false);
        setSelectedRolledBackTask(task);
        setShowTaskStatus(false);
        setShowFirstHalf(false);
        setShowSecondHalf(false);
        setShowCompletedTaskStatus(true);
        await fetchRolledBackTasks(); // Refresh rolled-back tasks
      }
    } catch (error) {
      console.error("Error loading task details:", error);
      toast.error("Error loading task details", {
        className: "gradient-toast",
        bodyClassName: "gradient-toast-body",
        progressClassName: "gradient-toast-progress",
      });
    }
  };

  // If still loading, show a loading message
  if (loading) {
    return (
      <div className="loader-container">
        <span className="loader"></span>
      </div>
    );
  }

  const assignTask = () => {
    if (showTaskStatus == true) {
      setNewTask(true);
      setShowFirstHalf(false);
      setShowSecondHalf(false);
      setShowTaskStatus(false);
      setShowCompletedTaskStatus(false);
    } else {
      setShowFirstHalf(true);
      setShowSecondHalf(true);
      setShowTaskStatus(true);
      setShowCompletedTaskStatus(false);
      setNewTask(false);
    }
  };

  const clickAssignSubmitButton = () => {
    setNewTask(false);
    setShowTaskStatus(true);
    setShowFirstHalf(true);
    setShowSecondHalf(true);
    setShowCompletedTaskStatus(false);
  };

  //  For in-task row rollback feedback
  const showFeedbackForm = () => {
    if (showFeedback == true) {
      setButtonAction("approve");
      setShowFeedback(false);
    } else {
      setShowFeedback(true);
      setShowFeedback(true);
      setButtonAction("disapprove");
    }
  };
  const launchedTaskWindowController = () => {
    if (launchedTaskWindow === true) {
      setLaunchedWindow(false);
      setShowFirstHalf(true);
      setShowSecondHalf(true);
      setTopRowTitleSection(true);
    } else {
      setLaunchedWindow(true);
      setShowFirstHalf(false);
      setShowSecondHalf(false);
      setTopRowTitleSection(false);
      setShowLaunchedTaskDetail(false);
    }
  };
  const launchedTaskDetailWindowController = () => {
    if (showLaunchedTaskDetail === true) {
      setShowLaunchedTaskDetail(false);
      setLaunchedWindow(true);
    } else {
      setShowLaunchedTaskDetail(true);
      setLaunchedWindow(false);
    }
  };

  const handlePreviewClick = (task) => {
    setSelectedLaunchedTasks(task);
    launchedTaskDetailWindowController();
  };
  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return {
          backgroundColor: "#5eb35eb7",
        };
      case "Pending":
        return {
          backgroundColor: "rgba(255, 145, 0, 0.69)",
        };
      case "Roll Back":
        return {
          backgroundColor: "rgba(245, 65, 0, 0.69)",
        };
      case "Posted":
        return {
          backgroundColor: "rgba(172, 5, 255, 0.76)",
        };
      default:
        return {};
    }
  };
  // Add this helper at the top of your component (before ContentManagement)
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  // Handler for checkbox changes:
  const handlePlatformCheckbox = (e) => {
    const { name, checked } = e.target;
    setTaskForm((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };
  return (
    <div className="content-management-page">
      {topRowTitleSection && (
        <div className="task-title-and-new-task">
          <div className="task-title">Tasks</div>
          <div className="new-task-button" onClick={assignTask}>
            + Assign New Task
          </div>
          <div className="approved-list-container">
            <span className="tooltiptext">Launched Reports</span>
            <div
              className="appproved-list-btn"
              onClick={() => launchedTaskWindowController()}
            >
              <LuNotepadText
                style={{ height: "30px", width: "30px", color: "grey" }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="task-row">
        {/* First Half */}
        <div className="task-boxes">
          {NewTask && (
            <div className="assign-new-task">
              <div className="assign-new-task-row">
                <div className="new-task-form-title">
                  Add New Task <MdAddTask style={{ marginLeft: "8px" }} />
                </div>
                <img
                  onClick={() => assignTask(false)}
                  width="48"
                  height="48"
                  src="https://img.icons8.com/fluency/48/delete-sign.png"
                  alt="delete-sign"
                  className="status-cross-symbol"
                />
              </div>

              <form className="new-task-form" onSubmit={taskHandleSubmit}>
                <div className="new-task-row">
                  <div className="new-task-row-input">
                    <label htmlFor="title">
                      Task Title: <span className="red-imp">*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      className="new-task-title"
                      placeholder="e.g., Summer Campaign"
                      value={taskForm.title}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="new-task-row-input">
                    <label htmlFor="taskpurpose">Task Objective:</label>
                    <input
                      type="text"
                      name="taskpurpose"
                      className="new-task-title"
                      placeholder="e.g., Launch new product"
                      value={taskForm.taskpurpose}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="new-task-row-input">
                    <label htmlFor="headline">Main Headline:</label>
                    <input
                      type="text"
                      name="headline"
                      className="new-task-title"
                      placeholder="e.g., Meet the New Smartwatch"
                      value={taskForm.headline}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="new-task-row-input">
                    <label htmlFor="calltoaction">Tagline for Lead:</label>
                    <input
                      type="text"
                      name="calltoaction"
                      className="new-task-title"
                      placeholder="e.g., Shop Now | 50% Offer"
                      value={taskForm.calltoaction}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="new-task-row-input">
                    <label htmlFor="description">Description:</label>
                    <textarea
                      name="description"
                      className="new-task-des"
                      placeholder="e.g., Fun tone, eco-friendly"
                      value={taskForm.description}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>

                  <div className="new-task-row-input">
                    <label htmlFor="referenceimage">
                      Reference Flyer or Product:
                    </label>
                    <input
                      type="file"
                      name="referenceimage"
                      className="img-input"
                      accept="image/*"
                    />
                  </div>
                  <div className="for-date-row add">
                    <div className="new-task-input-box">
                      <label
                        htmlFor="submissionForReview"
                        className="new-task-date-label"
                      >
                        Submission for Review:<span className="red-imp">*</span>
                      </label>
                      <input
                        type="date"
                        name="submissionForReview"
                        className="new-task-date"
                        value={taskForm.submissionForReview}
                        onChange={handleInputChange}
                        min={getTomorrowDate()}
                      />
                    </div>

                    <div className="new-task-input-box">
                      <label
                        htmlFor="targetPostingDate"
                        className="new-task-date-label"
                      >
                        Target Posting Date:<span className="red-imp">*</span>
                      </label>
                      <input
                        type="date"
                        name="targetPostingDate"
                        className="new-task-date"
                        value={taskForm.targetPostingDate}
                        onChange={handleInputChange}
                        min={getTomorrowDate()}
                      />
                    </div>
                  </div>
                  <div className="social-checkbox-container">
                    <label className="new-task-date-label">
                      Select Platforms:
                    </label>

                    <div className="social-checkbox">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="platform_x"
                          checked={taskForm.platform_x}
                          onChange={handlePlatformCheckbox}
                        />
                        <span className="checkmark"></span>
                        <img
                          src={x}
                          className="checkbox__textwrapper"
                          alt="X"
                        />
                      </label>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="platform_fb"
                          checked={taskForm.platform_fb}
                          onChange={handlePlatformCheckbox}
                        />
                        <span className="checkmark"></span>
                        <img
                          src={fb}
                          className="checkbox__textwrapper"
                          alt="Facebook"
                        />
                      </label>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="platform_insta"
                          checked={taskForm.platform_insta}
                          onChange={handlePlatformCheckbox}
                        />
                        <span className="checkmark"></span>
                        <img
                          src={insta}
                          className="checkbox__textwrapper"
                          alt="Instagram"
                        />
                      </label>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="platform_li"
                          checked={taskForm.platform_li}
                          onChange={handlePlatformCheckbox}
                        />
                        <span className="checkmark"></span>
                        <img
                          src={li}
                          className="checkbox__textwrapper"
                          alt="LinkedIn"
                        />
                      </label>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="platform_via_mail"
                          checked={taskForm.platform_via_mail}
                          onChange={handlePlatformCheckbox}
                        />
                        <span className="checkmark"></span>
                        <img
                          src={mail}
                          className="checkbox__textwrapper mail-icn"
                          alt="Mail"
                        />
                      </label>
                    </div>
                  </div>
                </div>

                <div className="new-task-row-submit">
                  <button
                    type="submit"
                    className="new-task-row-submit-btn"
                    disabled={
                      submitStatus === "submitting" ||
                      submitStatus === "submitted"
                    }
                  >
                    {submitStatus === "submitting"
                      ? "Submitting..."
                      : submitStatus === "submitted"
                      ? "Submitted"
                      : "Submit Task"}
                    <VscTasklist
                      style={{
                        marginLeft: "8px",
                        height: "30px",
                        width: "30px",
                      }}
                    />
                  </button>
                </div>
              </form>
            </div>
          )}
          {showFirstHalf && (
            <div className="task-arrows">
              <img
                src={backicn}
                alt=""
                className="assign-task-btn back"
                onClick={scrollLeft}
              />
              {tempRowStatus ? (
                <>
                  <div className="task-row-container" ref={scrollRef}>
                    {tasks.map((task) => (
                      <div className="box" key={task._id}>
                        <div
                          className="cart-task-box-wrapper"
                          onClick={() => taskStatus(task._id)}
                        >
                          <div className="cart-task-box">
                            <div className="top-id-card">
                              <div className="name-task">Task id:</div>
                              <div className="task-number">#{task.taskId}</div>
                            </div>
                            <div className="bottom-title-card">
                              <div className="task-box-title">{task.title}</div>
                              <button
                                className="cart-task-btn"
                                onClick={() => taskStatus(task._id)}
                              >
                                <span>View</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="temp-row-container tsk">
                  <div className="temp-title">
                    Click above to add your task!
                  </div>
                  <div className="temp-img"> </div>
                </div>
              )}
              <img
                src={nexticn}
                alt=""
                className="assign-task-btn next"
                onClick={scrollRight}
              />
            </div>
          )}
          {showCurrentTaskStatus && (
            <div className="show-task-status-container">
              <div className="close-button-row">
                <img
                  onClick={() => taskStatus(false)}
                  width="48"
                  height="48"
                  src="https://img.icons8.com/fluency/48/delete-sign.png"
                  alt="delete-sign"
                  className="status-cross-symbol"
                />
              </div>
              <div className="status-top-floor">
                <div className="status-top-floor-row-1">
                  <div className="status-col-1">
                    <div className="status-row client-padding">
                      <div className="status-task-id">
                        <div className="task-id for-gradient-font">Task ID</div>
                        <div className="task-id-number">
                          #{selectedTask?.taskId}
                        </div>
                      </div>

                      <div
                        className="task-current-status"
                        style={getStatusClass(selectedTask.currentStatus)}
                      >
                        {selectedTask.currentStatus}
                      </div>
                      <div className="status-task-title">
                        <div className="task-title-status">Task Title</div>
                        <div className="task-title-name-status">
                          {selectedTask?.title}
                        </div>
                      </div>
                      {selectedTask.taskpurpose && (
                        <div className="status-task-title">
                          <div className="task-title-status">
                            Task Objective
                          </div>
                          <div className="task-title-name-status">
                            {selectedTask?.taskpurpose}
                          </div>
                        </div>
                      )}
                      {selectedTask.headline && (
                        <div className="status-task-title">
                          <div className="task-title-status">Main Headline</div>
                          <div className="task-title-name-status">
                            {selectedTask?.headline}
                          </div>
                        </div>
                      )}
                      {selectedTask.calltoaction && (
                        <div className="status-task-title">
                          <div className="task-title-status ">
                            Tagline for Lead
                          </div>
                          <div className="task-title-name-status">
                            {selectedTask?.calltoaction}
                          </div>
                        </div>
                      )}
                      {selectedTask.description && (
                        <div className="status-task-des">
                          <div className="task-title-status">Description</div>
                          <div className="task-title-name-status">
                            {selectedTask?.description}
                          </div>
                        </div>
                      )}
                      <div className="for-date-row">
                        <div className="status-task-dates">
                          <label className="task-title-status">
                            Target Date
                          </label>
                          <div className="status-target-date">
                            <input
                              type="date"
                              name="targetPostingDate"
                              value={formatDateForDisplay(
                                selectedTask?.submissionForReview
                              )}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="status-task-dates">
                          <label className="task-title-status">
                            Deadline Date
                          </label>
                          <div className="status-deadline-date">
                            <input
                              type="date"
                              name="submissionForReview"
                              value={formatDateForDisplay(
                                selectedTask?.targetPostingDate
                              )}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      {(selectedTask.platform_x ||
                        selectedTask.platform_fb ||
                        selectedTask.platform_insta ||
                        selectedTask.platform_li ||
                        selectedTask.platform_via_mail) && (
                        <div className="platform-row-response">
                          <label className="task-title-status">
                            Selected Platforms has to Post:
                          </label>
                          <div className="social-checkbox">
                            {selectedTask.platform_x && (
                              <img src={x} className="checkbox__textwrapper" />
                            )}
                            {selectedTask.platform_fb && (
                              <img src={fb} className="checkbox__textwrapper" />
                            )}
                            {selectedTask.platform_insta && (
                              <img
                                src={insta}
                                className="checkbox__textwrapper"
                              />
                            )}
                            {selectedTask.platform_li && (
                              <img src={li} className="checkbox__textwrapper" />
                            )}
                            {selectedTask.platform_via_mail && (
                              <img
                                src={mail}
                                className="checkbox__textwrapper"
                              />
                            )}
                          </div>
                        </div>
                      )}
                      {selectedTask.referenceImage && (
                        <div className="info-group-img">
                          <label className="task-title-status">
                            Referene Image
                          </label>
                          <a
                            href={selectedTask.referenceImage}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={selectedTask.referenceImage}
                              alt="Brand Relate Image 6"
                              className="profile-logo"
                            />
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="status-col-2">
                    <div className="status-title-preview">Task Preview</div>
                    <div className="task-preview-img-container">
                      <img
                        src={
                          selectedTask?.doneTaskImage &&
                          selectedTask.doneTaskImage.trim() !== ""
                            ? selectedTask.doneTaskImage
                            : "https://productionhussmestorage.blob.core.windows.net/hussmeassets/Work in progress image.png"
                        }
                        className="task-preview-img"
                        alt="Task Preview"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="status-col-3">
                <div className="status-task-btns">
                  {selectedTask.rollbackFeedback.length > 0 && (
                    <div className="past-rollback">
                      <h3>Rollback Feedback</h3>
                      <ul>
                        {selectedTask.rollbackFeedback
                          .slice(-4) // Only show the last 4 feedback items
                          .map((feedback, index, arr) => (
                            <li
                              key={
                                arr.length === 4
                                  ? index +
                                    selectedTask.rollbackFeedback.length -
                                    4
                                  : index
                              }
                            >
                              {feedback.clientSuggestImage ? (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.clientSuggestImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={feedback.clientSuggestImage}
                                      alt="Brand Relate Image 6"
                                      className="profile-logo"
                                    />
                                  </a>
                                </div>
                              ) : (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.doneTaskImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={feedback.doneTaskImage}
                                      alt="Brand Relate Image 6"
                                      className="profile-logo"
                                    />
                                  </a>
                                </div>
                              )}
                              <p className="feed-index">
                                {selectedTask.rollbackFeedback.length > 4
                                  ? selectedTask.rollbackFeedback.length -
                                    4 +
                                    index +
                                    1
                                  : index + 1}
                                .<p>{feedback.feedback}</p>
                              </p>
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                  <div className="row-3-col-2-btn">
                    <button
                      className="custom-button-2 delete-task-btn "
                      onClick={() => handleDeleteTask(selectedTask._id)}
                    >
                      Remove Task
                    </button>
                    <button
                      className={
                        buttonAction && buttonAction !== "approve"
                          ? "custom-button-disable"
                          : "custom-button delete-task-btn"
                      }
                      onClick={handleApprove}
                      disabled={buttonAction && buttonAction !== "approve"}
                    >
                      <span className="button-content">
                        <span className="button-text">Approve</span>
                        <span className="button-icon">✅</span>
                      </span>
                    </button>
                    <button
                      className="delete-task-btn "
                      onClick={() => {
                        showFeedbackForm();
                      }}
                    >
                      <span className="button-content">
                        <span className="button-text">Refer Back</span>
                        <span className="button-icon">🔄️</span>
                      </span>
                    </button>
                    {showFeedback && (
                      <div className="status-feedback-form">
                        <textarea
                          className="feedback-textarea"
                          placeholder="Leave your feedback"
                          value={feedbackText}
                          onChange={(e) => setFeedbackText(e.target.value)}
                        ></textarea>
                        <div className="new-task-row-input">
                          <label htmlFor="clientSuggestImage">
                            Suggestion:
                          </label>
                          <input
                            type="file"
                            name="clientSuggestImage"
                            className="img-input"
                            accept="image/*"
                            id="clientSuggestImage"
                          />
                        </div>
                        <button
                          className="submit-feedback-btn"
                          disabled={
                            submitStatus === "submitting" ||
                            submitStatus === "submitted"
                          }
                          onClick={async () => {
                            if (!selectedTask?._id) {
                              toast.error("No task selected", {
                                className: "gradient-toast",
                                bodyClassName: "gradient-toast-body",
                                progressClassName: "gradient-toast-progress",
                              });
                              return;
                            }
                            if (!feedbackText.trim()) {
                              toast.error(
                                "Please provide feedback before rolling back",
                                {
                                  className: "gradient-toast",
                                  bodyClassName: "gradient-toast-body",
                                  progressClassName: "gradient-toast-progress",
                                }
                              );
                              return;
                            }
                            const token = localStorage.getItem("token");
                            try {
                              setSubmitStatus("submitting");
                              // Prepare form data
                              const formData = new FormData();
                              formData.append("feedback", feedbackText.trim());
                              // Add doneTaskImage as string (from selectedTask)
                              if (selectedTask?.doneTaskImage) {
                                formData.append(
                                  "doneTaskImageUrl",
                                  selectedTask.doneTaskImage
                                );
                              }
                              // Add clientSuggestImage as file
                              const fileInput =
                                document.getElementById("clientSuggestImage");
                              if (fileInput && fileInput.files[0]) {
                                formData.append(
                                  "clientSuggestImage",
                                  fileInput.files[0]
                                );
                              }
                              // Send feedback with image and doneTaskImageUrl
                              await axios.put(
                                `${process.env.REACT_APP_API_URL}/task/add-feedback-image/${selectedTask._id}`,
                                formData,
                                {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                    // Do not set Content-Type, let Axios handle it for FormData
                                  },
                                }
                              );
                              // Then, update the task status to "Roll Back"
                              await axios.put(
                                `${process.env.REACT_APP_API_URL}/task/update-task/${selectedTask._id}`,
                                { currentStatus: "Roll Back" },
                                {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                  },
                                }
                              );
                              toast.success("Task rolled back with feedback", {
                                className: "gradient-toast",
                                bodyClassName: "gradient-toast-body",
                                progressClassName: "gradient-toast-progress",
                              });
                              setFeedbackText("");
                              setButtonAction("approve");
                              setShowFeedback(false);
                              await fetchTasks();
                              taskStatus(false);
                              setSubmitStatus("submitted");
                              setTimeout(() => setSubmitStatus("idle"), 1500);
                            } catch (error) {
                              console.error(
                                "Error rolling back task:",
                                error.response?.data || error
                              );
                              toast.error(
                                error.response?.data?.message ||
                                  "Error rolling back task",
                                {
                                  className: "gradient-toast",
                                  bodyClassName: "gradient-toast-body",
                                  progressClassName: "gradient-toast-progress",
                                }
                              );
                              setSubmitStatus("idle");
                            }
                          }}
                        >
                          {submitStatus === "submitting"
                            ? "Submitting..."
                            : submitStatus === "submitted"
                            ? "Submitted"
                            : "Submit"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Second Half */}
      {showSecondHalf && (
        <>
          <div className="task-approved-row">
            <div className="approve-title"> Approved & Yet to launch 🚀</div>
            <div className="task-arrows">
              <img
                src={backicn}
                alt=""
                className="assign-task-btn back"
                onClick={approvedScrollLeft}
              />
              {tempYetRowStatus ? (
                <div
                  className="task-approved-row-container"
                  ref={approvedScrollRef}
                >
                  {approvedTasks.map((task) => (
                    <div
                      className="yet-task-box-wrapper"
                      key={task._id}
                      onClick={() => completedTask(task._id)}
                    >
                      <div className="yet-task-box">
                        <div className="inner-triangle-container">
                          <div className="yet-task-id">
                            <div className="yet-id">#{task.taskId}</div>
                          </div>
                          <button
                            className="yet-preview-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              completedTask(task._id);
                            }}
                          >
                            Preview
                          </button>
                          <div className="yet-task-title">{task.title}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="temp-row-container yet">
                  <div className="yet-temp-img"> </div>
                  <div className="temp-title">
                    Task nearly complete? Let’s check it off!
                  </div>
                </div>
              )}

              <img
                src={nexticn}
                alt=""
                className="assign-task-btn next"
                onClick={approvedScrollRight}
              />
            </div>
          </div>
        </>
      )}
      {showCompletedTaskStatus && (
        <div className="yet-show-task-status-container">
          <div className=" close-button-row">
            <img
              onClick={() => completedTask(false)}
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/delete-sign.png"
              alt="delete-sign"
              className="status-cross-symbol"
            />
          </div>
          <div className="status-top-floor">
            <div className="status-top-floor-row-1">
              <div className="status-col-1">
                <div className="status-row client-padding">
                  <div className="status-task-id">
                    <div className="task-id">Task ID</div>
                    <div className="task-id-number">
                      #{selectedRolledBackTask?.taskId}
                    </div>
                  </div>
                  <div
                    className="task-current-status"
                    style={getStatusClass(selectedRolledBackTask.currentStatus)}
                  >
                    {selectedRolledBackTask.currentStatus}
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Task Title</div>
                    <div className="task-title-name-status task-h">
                      {selectedRolledBackTask?.title}
                    </div>
                  </div>
                  {selectedRolledBackTask.taskpurpose && (
                    <div className="status-task-title">
                      <div className="task-title-status">Task Objective</div>
                      <div className="task-title-name-status">
                        {selectedRolledBackTask?.taskpurpose}
                      </div>
                    </div>
                  )}
                  {selectedRolledBackTask.headline && (
                    <div className="status-task-title">
                      <div className="task-title-status">Main Headline</div>
                      <div className="task-title-name-status">
                        {selectedRolledBackTask?.headline}
                      </div>
                    </div>
                  )}
                  {selectedRolledBackTask.calltoaction && (
                    <div className="status-task-title">
                      <div className="task-title-status ">Tagline for Lead</div>
                      <div className="task-title-name-status">
                        {selectedRolledBackTask?.calltoaction}
                      </div>
                    </div>
                  )}
                  {selectedRolledBackTask.description && (
                    <div className="status-task-des">
                      <div className="task-title-status">Description</div>
                      <div className="task-title-name-status">
                        {selectedRolledBackTask?.description}
                      </div>
                    </div>
                  )}

                  <div className="for-date-row">
                    <div className="status-task-dates">
                      <label className="task-title-status">Target Date</label>
                      <div className="status-target-date">
                        <input
                          type="date"
                          name="targetPostingDate"
                          value={formatDateForDisplay(
                            selectedRolledBackTask?.submissionForReview
                          )}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="status-task-dates">
                      <label className="task-title-status">Deadline Date</label>
                      <div className="status-deadline-date">
                        <input
                          type="date"
                          name="submissionForReview"
                          value={formatDateForDisplay(
                            selectedRolledBackTask?.targetPostingDate
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="platform-row-response">
                    <label className="task-title-status">
                      Selected Platforms has to Post:
                    </label>
                    <div className="social-checkbox">
                      {selectedRolledBackTask.platform_x && (
                        <img src={x} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_fb && (
                        <img src={fb} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_insta && (
                        <img src={insta} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_li && (
                        <img src={li} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_via_mail && (
                        <img src={mail} className="checkbox__textwrapper" />
                      )}
                    </div>
                  </div>
                  {selectedRolledBackTask.referenceImage && (
                    <div className="info-group-img">
                      <label className="task-title-status">
                        Reference Image
                      </label>
                      <a
                        href={selectedRolledBackTask.referenceImage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={selectedRolledBackTask.referenceImage}
                          alt="Brand Relate Image 6"
                          className="profile-logo"
                        />
                      </a>
                    </div>
                  )}
                </div>
              </div>
              {selectedRolledBackTask.rollbackFeedback.length > 0 && (
                <div className="past-rollback">
                  <h3>Rollback Feedback</h3>
                  <ul>
                    {selectedRolledBackTask.rollbackFeedback.map(
                      (feedback, index) => (
                        <li key={index}>
                          {feedback.clientSuggestImage ? (
                            <div className="info-group-img">
                              <a
                                href={feedback.clientSuggestImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={feedback.clientSuggestImage}
                                  alt="Brand Relate Image 6"
                                  className="profile-logo"
                                />
                              </a>
                            </div>
                          ) : (
                            <div className="info-group-img">
                              <a
                                href={feedback.doneTaskImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={feedback.doneTaskImage}
                                  alt="Brand Relate Image 6"
                                  className="profile-logo"
                                />
                              </a>
                            </div>
                          )}
                          <p className="feed-index">
                            {index + 1}.<p>{feedback.feedback}</p>
                          </p>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              )}
              {selectedRolledBackTask.doneTaskImage && (
                <div className="status-col-2">
                  <div className="status-title-preview">Task Preview</div>
                  <div className="task-preview-img-container">
                    <img
                      src={selectedRolledBackTask?.doneTaskImage}
                      className="yet-task-preview-img"
                      alt=""
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {launchedTaskWindow && (
        <div className="launch-container">
          <div className="launched-page-title-exit-row">
            <div className="approve-title"> Posted Tasks🚀 </div>
            <div
              className="appproved-list-btn"
              onClick={() => launchedTaskWindowController()}
            >
              <img
                width="48"
                height="48"
                src="https://img.icons8.com/fluency/48/delete-sign.png"
                alt="delete-sign"
                className="status-cross-symbol"
              />
            </div>
          </div>

          <div className="task-arrows">
            <img
              src={backicn}
              alt=""
              className="assign-task-btn back"
              onClick={approvedScrollLeft}
            />
            {tempYetLaunchedRowStatus ? (
              <div
                className="task-approved-row-container"
                ref={approvedScrollRef}
              >
                {launchedTasks.map((task) => (
                  <div
                    className="yet-task-box-wrapper"
                    key={task._id}
                    // Remove onClick from here to avoid accidental window open
                  >
                    <div
                      className="yet-task-box"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePreviewClick(task);
                      }}
                    >
                      <div className="inner-triangle-container">
                        <div className="yet-task-id">
                          <div className="yet-id">#{task.taskId}</div>
                        </div>
                        <button
                          className="yet-preview-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePreviewClick(task);
                          }}
                        >
                          Preview
                        </button>
                        <div className="yet-task-title">{task.title}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="temp-row-container yet">
                <div className="yet-temp-img"> </div>
                <div className="temp-title">
                  Task nearly complete? Let’s check it off!
                </div>
              </div>
            )}

            <img
              src={nexticn}
              alt=""
              className="assign-task-btn next"
              onClick={approvedScrollRight}
            />
          </div>
        </div>
      )}
      {showLaunchedTaskDetail && (
        <div className="yet-show-task-status-container">
          <div className=" close-button-row">
            <img
              onClick={() => launchedTaskDetailWindowController()}
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/delete-sign.png"
              alt="delete-sign"
              className="status-cross-symbol"
            />
          </div>
          <div className="status-top-floor">
            <div className="status-top-floor-row-1">
              <div className="status-col-1">
                <div className="status-row client-padding">
                  <div className="status-task-id">
                    <div className="task-id">Task ID</div>
                    <div className="task-id-number">
                      #{selectedLaunchedTasks?.taskId}
                    </div>
                  </div>
                  <div
                    className="task-current-status"
                    style={getStatusClass(selectedLaunchedTasks.currentStatus)}
                  >
                    {selectedLaunchedTasks.currentStatus}
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Task Title</div>
                    <div className="task-title-name-status task-h">
                      {selectedLaunchedTasks?.title}
                    </div>
                  </div>
                  {selectedLaunchedTasks.taskpurpose && (
                    <div className="status-task-title">
                      <div className="task-title-status">Task Objective</div>
                      <div className="task-title-name-status">
                        {selectedLaunchedTasks?.taskpurpose}
                      </div>
                    </div>
                  )}
                  {selectedLaunchedTasks.headline && (
                    <div className="status-task-title">
                      <div className="task-title-status">Main Headline</div>
                      <div className="task-title-name-status">
                        {selectedLaunchedTasks?.headline}
                      </div>
                    </div>
                  )}
                  {selectedLaunchedTasks.calltoaction && (
                    <div className="status-task-title">
                      <div className="task-title-status ">Tagline for Lead</div>
                      <div className="task-title-name-status">
                        {selectedLaunchedTasks?.calltoaction}
                      </div>
                    </div>
                  )}
                  {selectedLaunchedTasks.description && (
                    <div className="status-task-des">
                      <div className="task-title-status">Description</div>
                      <div className="task-title-name-status">
                        {selectedLaunchedTasks?.description}
                      </div>
                    </div>
                  )}
                  <div className="for-date-row">
                    <div className="status-task-dates">
                      <label className="task-title-status">Target Date</label>
                      <div className="status-target-date">
                        <input
                          type="date"
                          name="targetPostingDate"
                          value={formatDateForDisplay(
                            selectedLaunchedTasks?.submissionForReview
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="status-task-dates">
                      <label className="task-title-status">Deadline Date</label>
                      <div className="status-deadline-date">
                        <input
                          type="date"
                          name="submissionForReview"
                          value={formatDateForDisplay(
                            selectedLaunchedTasks?.targetPostingDate
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  {selectedLaunchedTasks.adminPostComment && (
                    <div className="status-task-title">
                      <div className="task-title-status bright">
                        Admin Post Comments
                      </div>
                      <div className="task-title-name-status">
                        {selectedLaunchedTasks?.adminPostComment}
                      </div>
                    </div>
                  )}
                  <div className="platform-row-response">
                    <label className="task-title-status">
                      Selected Platforms has to Post:
                    </label>
                    <div className="social-checkbox">
                      {selectedLaunchedTasks.platform_x && (
                        <img src={x} className="checkbox__textwrapper" />
                      )}
                      {selectedLaunchedTasks.platform_fb && (
                        <img src={fb} className="checkbox__textwrapper" />
                      )}
                      {selectedLaunchedTasks.platform_insta && (
                        <img src={insta} className="checkbox__textwrapper" />
                      )}
                      {selectedLaunchedTasks.platform_li && (
                        <img src={li} className="checkbox__textwrapper" />
                      )}
                      {selectedLaunchedTasks.platform_via_mail && (
                        <img src={mail} className="checkbox__textwrapper" />
                      )}
                    </div>
                  </div>
                  {selectedLaunchedTasks.referenceImage && (
                    <div className="info-group-img">
                      <label className="task-title-status">
                        Reference Image
                      </label>
                      <a
                        href={selectedLaunchedTasks.referenceImage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={selectedLaunchedTasks.referenceImage}
                          alt="Brand Relate Image 6"
                          className="profile-logo"
                        />
                      </a>
                    </div>
                  )}
                </div>
              </div>
              {selectedLaunchedTasks.rollbackFeedback.length > 0 && (
                <div className="past-rollback">
                  <h3>Rollback Feedback</h3>
                  <ul>
                    {selectedLaunchedTasks.rollbackFeedback.map(
                      (feedback, index) => (
                        <li key={index}>
                          {feedback.clientSuggestImage ? (
                            <div className="info-group-img">
                              <a
                                href={feedback.clientSuggestImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={feedback.clientSuggestImage}
                                  alt="Brand Relate Image 6"
                                  className="profile-logo"
                                />
                              </a>
                            </div>
                          ) : (
                            <div className="info-group-img">
                              <a
                                href={feedback.doneTaskImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={feedback.doneTaskImage}
                                  alt="Brand Relate Image 6"
                                  className="profile-logo"
                                />
                              </a>
                            </div>
                          )}
                          <p className="feed-index">
                            {index + 1}.<p>{feedback.feedback}</p>
                          </p>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              )}
              <div className="status-col-2">
                <div className="status-title-preview">Task Preview</div>
                <div className="task-preview-img-container">
                  <img
                    src={selectedLaunchedTasks?.doneTaskImage}
                    className="yet-task-preview-img"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={true}
        transition={Zoom}
      />
    </div>
  );
}
